import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

class TSplashScreen extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {};

    static defaultProps = {};

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        return (
            <div>
                <div style={{ margin: "0, auto", textAlign: "center" }}>
                    <p>Loading app...</p>
                    <CircularProgress
                        size={118}
                        style={{ marginTop: "10", marginBottom: "10", margin: "0 auto", display: "block" }}
                    />
                </div>
            </div>
        );
    }
}

export default TSplashScreen;
